import { render } from "./QualityRecordEs.vue?vue&type=template&id=31543bd4&scoped=true"
import script from "./QualityRecordEs.vue?vue&type=script&lang=js"
export * from "./QualityRecordEs.vue?vue&type=script&lang=js"

import "./QualityRecordEs.vue?vue&type=style&index=0&id=31543bd4&lang=scss&scoped=true"
import "./QualityRecordEs.vue?vue&type=style&index=1&id=31543bd4&lang=scss"
import "./QualityRecordEs.vue?vue&type=style&index=2&id=31543bd4&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31543bd4"]])

export default __exports__